<template>
    <div class="title">
        <div class="module-title" v-if="caption">{{caption}}</div>
        <div class="module-sub-title" v-if="text">
            <span class="text" v-html="text">
            </span>
        </div>
        <slot :module="module"></slot>
    </div>
</template>
<script>
    export default {
        name: 'moduleTitle',
        props: {
            caption: String,
            text: String,
            module: Object
        }
    }
</script>
<style lang="less" scoped>

</style>
